import React from 'react';
import './App.css';
import './Data/Axios'
import {QueryClient, QueryClientProvider} from "react-query";
import {persistStore} from "redux-persist";
import {store} from "./Store/Store";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {RouterProvider} from "react-router-dom";
import {AnimatePresence} from "framer-motion";
import {router} from "./Routing";
import {CustomThemeProvider} from "./CustomThemeProvider";

const persistor = persistStore(store);
const queryClient = new QueryClient();

function App() {
    return (
        <div className="App">
            <QueryClientProvider client={queryClient}>
                {/*Redux*/}
                <Provider store={store}>
                    {/*Redux*/}
                    <PersistGate persistor={persistor}>
                        <CustomThemeProvider>
                            <AnimatePresence mode="wait">
                                <RouterProvider router={router}/>
                            </AnimatePresence>
                        </CustomThemeProvider>
                    </PersistGate>
                </Provider>
            </QueryClientProvider>
        </div>
    );
}

export default App;
